import React from 'react';

export default function AaChainVis(): JSX.Element {
  return (
    <>
      <path
        d="M15.5195 1.27148C16.1992 0.79822 17.1371 0.963571 17.6142 1.64062L33.5175 24.2236C33.7302 24.5258 33.8145 24.8784 33.7831 25.2188V59.4971C33.7831 60.3254 33.1114 60.9969 32.2831 60.9971H27.4716C26.6433 60.997 25.9716 60.3254 25.9716 59.4971V27.0479L11.2157 6.0957C10.7388 5.41838 10.904 4.48505 11.5839 4.01172L15.5195 1.27148Z"
        fill="#3C65FB"
      />
      <path
        d="M15.5195 1.27148L14.9481 0.450793L14.948 0.45082L15.5195 1.27148ZM17.6142 1.64062L18.4318 1.06485L18.4316 1.06463L17.6142 1.64062ZM33.5175 24.2236L34.3351 23.6479L34.3351 23.6479L33.5175 24.2236ZM33.7831 25.2188L32.7873 25.1271L32.7831 25.1728V25.2188H33.7831ZM32.2831 60.9971V61.9971H32.2834L32.2831 60.9971ZM27.4716 60.9971L27.4715 61.9971H27.4716V60.9971ZM25.9716 27.0479H26.9716V26.7311L26.7892 26.4721L25.9716 27.0479ZM11.2157 6.0957L10.3981 6.67146L10.3982 6.6715L11.2157 6.0957ZM11.5839 4.01172L12.1553 4.83241L12.1553 4.83238L11.5839 4.01172ZM15.5195 1.27148L16.0908 2.09218C16.3191 1.93327 16.6364 1.98915 16.7967 2.21662L17.6142 1.64062L18.4316 1.06463C17.6378 -0.0620046 16.0794 -0.336832 14.9481 0.450793L15.5195 1.27148ZM17.6142 1.64062L16.7966 2.2164L32.6999 24.7994L33.5175 24.2236L34.3351 23.6479L18.4318 1.06485L17.6142 1.64062ZM33.5175 24.2236L32.6999 24.7993C32.7703 24.8994 32.7978 25.0135 32.7873 25.1271L33.7831 25.2188L34.7789 25.3104C34.8311 24.7433 34.6902 24.1522 34.3351 23.6479L33.5175 24.2236ZM33.7831 25.2188H32.7831V59.4971H33.7831H34.7831V25.2188H33.7831ZM33.7831 59.4971H32.7831C32.7831 59.7728 32.5593 59.997 32.2829 59.9971L32.2831 60.9971L32.2834 61.9971C33.6635 61.9967 34.7831 60.8779 34.7831 59.4971H33.7831ZM32.2831 60.9971V59.9971H27.4716V60.9971V61.9971H32.2831V60.9971ZM27.4716 60.9971L27.4717 59.9971C27.1954 59.997 26.9716 59.773 26.9716 59.4971H25.9716H24.9716C24.9716 60.8778 26.0911 61.9969 27.4715 61.9971L27.4716 60.9971ZM25.9716 59.4971H26.9716V27.0479H25.9716H24.9716V59.4971H25.9716ZM25.9716 27.0479L26.7892 26.4721L12.0333 5.5199L11.2157 6.0957L10.3982 6.6715L25.154 27.6237L25.9716 27.0479ZM11.2157 6.0957L12.0334 5.51994C11.8761 5.29656 11.9297 4.98946 12.1553 4.83241L11.5839 4.01172L11.0125 3.19103C9.87837 3.98064 9.60149 5.5402 10.3981 6.67146L11.2157 6.0957ZM11.5839 4.01172L12.1553 4.83238L16.0909 2.09215L15.5195 1.27148L14.948 0.45082L11.0125 3.19105L11.5839 4.01172Z"
        fill="#3C65FB"
      />
      <g clipPath="url(#clip0_414_23500)">
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 15.9562 4.07373)"
            fill="#E8EDFF"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 20.0857 9.72607)"
            fill="#E8EDFF"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 24.2153 15.3784)"
            fill="#E8EDFF"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 28.3449 21.0303)"
            fill="#E8EDFF"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 32.4744 26.6826)"
            fill="#E8EDFF"
          />
        </g>
        <rect
          width="26.2839"
          height="1"
          transform="matrix(0.589938 0.807448 -0.810577 0.585632 15.1456 4.65967)"
          fill="#E8EDFF"
        />
      </g>
      <g clipPath="url(#clip2_414_23500)">
        <g>
          <circle cx="30.1031" cy="56.9951" r="1.5" transform="rotate(-90 30.1031 56.9951)" fill="#E8EDFF" />
          <circle cx="30.1031" cy="49.9951" r="1.5" transform="rotate(-90 30.1031 49.9951)" fill="#E8EDFF" />
          <circle cx="30.1031" cy="42.9951" r="1.5" transform="rotate(-90 30.1031 42.9951)" fill="#E8EDFF" />
          <circle cx="30.1031" cy="35.9951" r="1.5" transform="rotate(-90 30.1031 35.9951)" fill="#E8EDFF" />
          <circle cx="30.1031" cy="28.9951" r="1.5" transform="rotate(-90 30.1031 28.9951)" fill="#E8EDFF" />
        </g>
        <rect
          x="29.6031"
          y="58.4951"
          width="33"
          height="1"
          transform="rotate(-90 29.6031 58.4951)"
          fill="#E8EDFF"
        />
      </g>
      <path
        d="M56.0567 1.27148C55.377 0.79822 54.4391 0.963571 53.962 1.64062L38.0587 24.2236C37.846 24.5258 37.7617 24.8784 37.7931 25.2188V59.4971C37.7931 60.3254 38.4648 60.9969 39.2931 60.9971H44.1046C44.9329 60.997 45.6046 60.3254 45.6046 59.4971V27.0479L60.3605 6.0957C60.8374 5.41838 60.6722 4.48505 59.9923 4.01172L56.0567 1.27148Z"
        fill="#3C65FB"
      />
      <path
        d="M56.0567 1.27148L56.6281 0.450793L56.6282 0.45082L56.0567 1.27148ZM53.962 1.64062L53.1444 1.06485L53.1446 1.06463L53.962 1.64062ZM38.0587 24.2236L37.2411 23.6479L37.2411 23.6479L38.0587 24.2236ZM37.7931 25.2188L38.7889 25.1271L38.7931 25.1728V25.2188H37.7931ZM39.2931 60.9971V61.9971H39.2928L39.2931 60.9971ZM44.1046 60.9971L44.1047 61.9971H44.1046V60.9971ZM45.6046 27.0479H44.6046V26.7311L44.787 26.4721L45.6046 27.0479ZM60.3605 6.0957L61.1781 6.67146L61.178 6.6715L60.3605 6.0957ZM59.9923 4.01172L59.4209 4.83241L59.4209 4.83238L59.9923 4.01172ZM56.0567 1.27148L55.4854 2.09218C55.2571 1.93327 54.9398 1.98915 54.7795 2.21662L53.962 1.64062L53.1446 1.06463C53.9384 -0.0620046 55.4968 -0.336832 56.6281 0.450793L56.0567 1.27148ZM53.962 1.64062L54.7796 2.2164L38.8763 24.7994L38.0587 24.2236L37.2411 23.6479L53.1444 1.06485L53.962 1.64062ZM38.0587 24.2236L38.8764 24.7993C38.8059 24.8994 38.7784 25.0135 38.7889 25.1271L37.7931 25.2188L36.7973 25.3104C36.7451 24.7433 36.886 24.1522 37.2411 23.6479L38.0587 24.2236ZM37.7931 25.2188H38.7931V59.4971H37.7931H36.7931V25.2188H37.7931ZM37.7931 59.4971H38.7931C38.7931 59.7728 39.0169 59.997 39.2933 59.9971L39.2931 60.9971L39.2928 61.9971C37.9127 61.9967 36.7931 60.8779 36.7931 59.4971H37.7931ZM39.2931 60.9971V59.9971H44.1046V60.9971V61.9971H39.2931V60.9971ZM44.1046 60.9971L44.1045 59.9971C44.3808 59.997 44.6046 59.773 44.6046 59.4971H45.6046H46.6046C46.6046 60.8778 45.4851 61.9969 44.1047 61.9971L44.1046 60.9971ZM45.6046 59.4971H44.6046V27.0479H45.6046H46.6046V59.4971H45.6046ZM45.6046 27.0479L44.787 26.4721L59.5429 5.5199L60.3605 6.0957L61.178 6.6715L46.4222 27.6237L45.6046 27.0479ZM60.3605 6.0957L59.5428 5.51994C59.7001 5.29656 59.6465 4.98946 59.4209 4.83241L59.9923 4.01172L60.5637 3.19103C61.6978 3.98064 61.9747 5.5402 61.1781 6.67146L60.3605 6.0957ZM59.9923 4.01172L59.4209 4.83238L55.4853 2.09215L56.0567 1.27148L56.6282 0.45082L60.5637 3.19105L59.9923 4.01172Z"
        fill="#3C65FB"
      />
      <g clipPath="url(#clip4_414_23500)">
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 55.62 4.07373)"
            fill="#E8EDFF"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 51.4905 9.72607)"
            fill="#E8EDFF"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 47.3609 15.3784)"
            fill="#E8EDFF"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 43.2313 21.0303)"
            fill="#E8EDFF"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 39.1018 26.6826)"
            fill="#E8EDFF"
          />
        </g>
        <rect
          width="26.2839"
          height="1"
          transform="matrix(-0.589938 0.807448 0.810577 0.585632 56.4306 4.65967)"
          fill="#E8EDFF"
        />
      </g>
      <g clipPath="url(#clip6_414_23500)">
        <g>
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 58.4951)" fill="#E8EDFF" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 51.4951)" fill="#E8EDFF" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 44.4951)" fill="#E8EDFF" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 37.4951)" fill="#E8EDFF" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 30.4951)" fill="#E8EDFF" />
        </g>
        <rect width="33" height="1" transform="matrix(0 -1 -1 0 41.9731 58.4951)" fill="#E8EDFF" />
      </g>
      <rect
        x="-0.120262"
        y="0.694702"
        width="24.8727"
        height="8.91985"
        rx="2"
        transform="matrix(-0.578282 -0.815837 0.818805 -0.573568 14.0466 32.143)"
        fill="#8DB800"
      />
      <g clipPath="url(#clip8_414_23500)">
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 6.05476 9.31982)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 10.1027 15.0308)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 14.1507 20.7417)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 18.1987 26.4526)"
            fill="#F6FFD7"
          />
        </g>
        <rect
          width="20.0118"
          height="1"
          transform="matrix(0.578282 0.815837 -0.818805 0.573568 5.81424 10.7095)"
          fill="#F6FFD7"
        />
      </g>
      <rect
        x="0.120262"
        y="0.694702"
        width="24.8727"
        height="8.91985"
        rx="2"
        transform="matrix(0.578282 -0.815837 -0.818805 -0.573568 57.8143 32.3392)"
        fill="#8DB800"
      />
      <g clipPath="url(#clip10_414_23500)">
        <g>
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 65.9452 9.31982)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 61.8973 15.0308)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 57.8493 20.7417)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 53.8013 26.4526)"
            fill="#F6FFD7"
          />
        </g>
        <rect
          width="20.0118"
          height="1"
          transform="matrix(-0.578282 0.815837 0.818805 0.573568 66.1858 10.7095)"
          fill="#F6FFD7"
        />
      </g>
      <defs>
        <clipPath id="clip0_414_23500">
          <rect
            width="26.2839"
            height="5.45688"
            fill="white"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 16.9519 3.35449)"
          />
        </clipPath>
        <clipPath id="clip2_414_23500">
          <rect width="32.6185" height="5.46765" fill="white" transform="matrix(0 -1 1 0 27.3693 58.4951)" />
        </clipPath>
        <clipPath id="clip4_414_23500">
          <rect
            width="26.2839"
            height="5.45688"
            fill="white"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 54.6243 3.35449)"
          />
        </clipPath>
        <clipPath id="clip6_414_23500">
          <rect width="32.6185" height="5.46765" fill="white" transform="matrix(0 -1 -1 0 44.2069 58.4951)" />
        </clipPath>
        <clipPath id="clip8_414_23500">
          <rect
            width="21.0118"
            height="4.9499"
            fill="white"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 6.85306 8.76074)"
          />
        </clipPath>
        <clipPath id="clip10_414_23500">
          <rect
            width="21.0118"
            height="4.9499"
            fill="white"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 65.1469 8.76074)"
          />
        </clipPath>
      </defs>
    </>
  );
}
